import Definitions from './Definitions';

export default Definitions;
